import React, { useState } from "react"

import { ToastProvider } from "../../contexts/ToastContext"

import VideoReviewsUploadLinks from "./VideoReviewsUploadLinks"

// Helper function to safely get CSRF token for SSR compatibility
const getCSRFToken = () => {
  if (typeof document === "undefined") return ""
  return (
    document.querySelector('[name="csrf-token"]')?.content ||
    document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ||
    ""
  )
}

/**
 * VideoReviewsRequestsPage
 * Allows practitioners to generate new upload links and manage active links.
 * Listing/approval of submitted videos now lives in VideoReviewsListPage.
 */
const VideoReviewsRequestsPage = ({ videoReviews, clients }) => {
  const [selectedClientId, setSelectedClientId] = useState(clients?.[0]?.id || "")

  return (
    <ToastProvider>
      <div className="w-full">
        {/* Create New Upload Link */}
        <div className="mb-6 rounded-lg border border-gray-light bg-white p-6 shadow-sm">
          <h5 className="mb-4 text-lg font-semibold text-gray-dark">Create New Upload Link</h5>
          <form action="/portal/video_reviews/create_video_upload_link" method="POST" className="w-full">
            <input type="hidden" name="authenticity_token" value={getCSRFToken()} />
            <div className="flex items-end space-x-4">
              <div className="grow">
                <label htmlFor="client-select" className="mb-1 block text-sm font-medium text-gray">
                  Select a Client
                </label>
                <select
                  id="client-select"
                  name="client_id"
                  value={selectedClientId}
                  onChange={(e) => setSelectedClientId(e.target.value)}
                  className="block w-full rounded-md border-gray-light shadow-sm focus:border-teal focus:ring focus:ring-teal-light focus:ring-opacity-50">
                  {clients && clients.length > 0 ? (
                    clients.map((client) => (
                      <option key={client.id} value={client.id}>
                        {client.first_name} {client.last_name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No clients found</option>
                  )}
                </select>
              </div>
              <button
                type="submit"
                disabled={!selectedClientId || (clients && clients.length === 0)}
                className="inline-flex h-10 items-center justify-center rounded-md border border-transparent bg-teal px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-teal-dark focus:outline-none focus:ring-2 focus:ring-teal-light focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
                Generate Link
              </button>
            </div>
          </form>
        </div>

        {/* Active Upload Links */}
        <VideoReviewsUploadLinks videoReviews={videoReviews || []} />
      </div>
    </ToastProvider>
  )
}

export default VideoReviewsRequestsPage
